import { defineSlotRecipe } from "@chakra-ui/react";
/** Notice colors and white actions stay scoped to alerts. */
const tone = (surface) => ({
    root: {
        "--alert-surface": `colors.${surface}`,
        "--alert-text": "colors.ink",
    },
});
export const alertRecipe = defineSlotRecipe({
    className: "alert",
    slots: ["root", "indicator", "title", "description", "content"],
    base: {
        root: {
            rounded: "control",
            borderWidth: "0",
            "--chakra-colors-fg-muted": "currentColor",
            "& :is(button, a.chakra-button, a[role='button'])": {
                bg: "white",
                color: "ink",
                borderWidth: "0",
                boxShadow: "none",
                _hover: { bg: "softCream" },
                _active: { bg: "softCream" },
                _focusVisible: {
                    outline: "2px solid",
                    outlineColor: "ink",
                    outlineOffset: "2px",
                    boxShadow: "0 0 0 2px white",
                },
            },
        },
        indicator: { color: "inherit" },
        title: { fontWeight: "600" },
        description: { fontSize: "13px", lineHeight: "1.5", color: "inherit" },
    },
    variants: {
        status: {
            info: tone("discoveryAccent"),
            warning: tone("orange.300"),
            success: tone("green.300"),
            error: tone("red.300"),
            neutral: tone("softCream"),
        },
        variant: {
            subtle: {
                root: { bg: "var(--alert-surface)", color: "var(--alert-text)" },
            },
            surface: {
                root: {
                    bg: "var(--alert-surface)",
                    color: "var(--alert-text)",
                    shadow: "none",
                },
                indicator: { color: "inherit" },
            },
            outline: {
                root: {
                    bg: "transparent",
                    color: "colorPalette.fg",
                    shadow: "none",
                },
                indicator: { color: "inherit" },
            },
            solid: {
                root: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast",
                },
                indicator: { color: "inherit" },
            },
        },
    },
});
